import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/(public)/p/$slug/")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/p/$slug/login", params })
  },
})
